'use client';

import { Header, Footer } from '../components';
import { ThemeProvider } from '../components/providers/ThemeProvider';
import { SmoothScrollProvider } from '../components/scroll/SmoothScrollProvider';
import navigation from '../content/navigation.json';
import Link from 'next/link';

// Custom Link component for Next.js
function NextLink({ href, children, ...props }) {
  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
}

// Contact info for the split menu
const contactInfo = {
  title: 'Kontakt',
  name: 'Sebastian Nawrot',
  address: 'Dorneystr. 45\n44149 Dortmund',
  phone: '+49 23116730433',
  email: 'sebastian@codeschnipsel.dev',
};

// Social links for the split menu
const socialLinks = [
  { label: 'LinkedIn', href: 'https://linkedin.com' },
  { label: 'GitHub', href: 'https://github.com' },
  { label: 'Twitter', href: 'https://twitter.com' },
];

export default function ClientLayout({ children }) {
  return (
    <ThemeProvider defaultTheme="light">
      {/* Skip to content for accessibility */}
      <a href="#main-content" className="skip-to-content">
        Zum Inhalt springen
      </a>

      {/* Header with split menu (opens from both sides) */}
      <Header
        logo="/images/general/logo-black.svg"
        logoWhite="/images/general/logo-white.svg"
        logoAlt="Codeschnipsel"
        navigation={navigation.mainNav}
        contactInfo={contactInfo}
        socialLinks={socialLinks}
        sticky={true}
        renderLink={NextLink}
      />

      {/* Smooth Scroll Container */}
      <SmoothScrollProvider enabled={true} damping={0.05}>
        {/* Main Content */}
        <main id="main-content">
          {children}
        </main>

        {/* Footer */}
        <Footer
          logo="/images/general/logo-white.svg"
          logoAlt="Codeschnipsel"
          navigation={navigation.footerNav}
          social={navigation.social}
          renderLink={NextLink}
        />
      </SmoothScrollProvider>
    </ThemeProvider>
  );
}
